import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-modal'
import ModalItem from './../../../components/Modal/ModalItem'
import AdoptionMiddleware from './../../../modules/adoption/middleware'
import DataTable from '../../../components/DataTable/DataTableAdoptions'
import BooksMiddleware from './../../../modules/books/middleware'

const mapStateToProps = ({ adoption, auth }) => ({
  adoptions: adoption.adoptions,
  role: auth.userRole.role
})

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({
    toggleModal: () => BooksMiddleware.modalBooksToggleView(),
    toggleDialog: () => AdoptionMiddleware.dialogAdoptionToggleView(),
    changeItemDialog: (newItem) => AdoptionMiddleware.dialogAdoptionChangeItem(newItem),
    removeAdoption: (id) => AdoptionMiddleware.removeAdoption(id)
  }, dispatch)
)

class DataTableAdoptionsContainer extends Component {
  state = {
    item: null,
    openModal: false
  }

  onClickRemove = (id) => {
    this.props.removeAdoption(id)
  }
  toggleDialog = () => {
    this.props.toggleDialog()
  }
  changeItemDialog = (newItem) => {
    this.props.changeItemDialog(newItem)
  }
  handleOpenModal = (id, book) => this.setState({ openModal: true, item: book })
  handleCloseModal = () => this.setState({ openModal: false })
  render () {
    return (
      <div>
        <DataTable
          onClickRemove={this.onClickRemove}
          changeItemDialog={this.changeItemDialog}
          handleOpenModal={this.handleOpenModal}
          toggleDialog={this.toggleDialog}
          list={this.props.adoptions}
          role={this.props.role}
        />
        <Dialog
          isOpen={this.state.openModal}
          contentLabel='Modal'
          onRequestClose={this.handleCloseModal}
          className='dialog dialog--modal'
          >
          <ModalItem
            item={this.state.item}
            handleCloseModal={this.handleCloseModal}
          />
        </Dialog>
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DataTableAdoptionsContainer))



// WEBPACK FOOTER //
// ./src/containers/DataTableContainers/Adoptions/index.js